export default __webpack_public_path__ + "static/EC-2-10fd26f7ed5207ddee390cc4b6cd40d1.png";